import { render } from "./ClassList.vue?vue&type=template&id=ae03cbc8&scoped=true"
import script from "./ClassList.vue?vue&type=script&lang=js"
export * from "./ClassList.vue?vue&type=script&lang=js"

import "./ClassList.vue?vue&type=style&index=0&id=ae03cbc8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ae03cbc8"

export default script